var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7559 14.255H14.9659L14.6859 13.985C15.6659 12.845 16.2559 11.365 16.2559 9.755C16.2559 6.165 13.3459 3.255 9.75586 3.255C6.16586 3.255 3.25586 6.165 3.25586 9.755C3.25586 13.345 6.16586 16.255 9.75586 16.255C11.3659 16.255 12.8459 15.665 13.9859 14.685L14.2559 14.965V15.755L19.2559 20.745L20.7459 19.255L15.7559 14.255ZM9.75586 14.255C7.26586 14.255 5.25586 12.245 5.25586 9.755C5.25586 7.26501 7.26586 5.255 9.75586 5.255C12.2459 5.255 14.2559 7.26501 14.2559 9.755C14.2559 12.245 12.2459 14.255 9.75586 14.255Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilled);
export default __webpack_public_path__ + "static/media/SearchFilled.3493c882a342a1782449111801e08579.svg";
export { ForwardRef as ReactComponent };